// Envio = invoice da empresa para um cliente (debita a carteira do asset da
// empresa E do cliente). Destino = carteira (hash) + rede (network).

export interface IEnvio {
  id: string | number;
  client?: { id: number; name: string } | null;
  asset?: { id: number; symbol: string; name: string } | null;
  hash?: string | null;
  network?: { id: number; name: string } | null;
  value: string;
  status: string;
  date: string; // createdAt (já formatado pelo Api)
}

export interface EnvioForm {
  user_id: number | "";
  asset_id: number | "";
  hash: string;
  network_id: number | "";
  value: string;
  date: Date | null;
}

export const INITIAL_ENVIO_FORM: EnvioForm = {
  user_id: "",
  asset_id: "",
  hash: "",
  network_id: "",
  value: "",
  date: null,
};

export interface CreateSendPayload {
  organization_id: number;
  user_id: number;
  asset_id: number;
  value: string;
  hash?: string;
  network_id?: number;
}

export interface EnvioFilters {
  user_id: number | "";
  asset_id: number | "";
  hash: string;
  start: Date | null;
  end: Date | null;
  minValue: string;
  maxValue: string;
}

export const INITIAL_ENVIO_FILTERS: EnvioFilters = {
  user_id: "",
  asset_id: "",
  hash: "",
  start: null,
  end: null,
  minValue: "",
  maxValue: "",
};
